import axios from "axios";
import { StockCommodityExposure, StockCommodityExposureHeaders, StockCommodityMoves } from "@/models/stock-commodity";
import { List, ListQueryParams } from "@/models/table";

export const getStockCommodityExposure = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, universe_id, next_page_url } = params;

    const url = next_page_url || `/API/v2/id/${universe_id}/commodities/list/exposure?&dgformat`;
    const defaultParams = next_page_url ? {} : { length: page_size, page, ...filter_options };

    const res = await axios.get<List<StockCommodityExposure, StockCommodityExposureHeaders>>(url, {
        params: {
            ...defaultParams,
        },
    });

    return res.data;
};

export const getStockCommodityMoves = async (filter: number | string): Promise<StockCommodityMoves> => {
    const res = await axios.get<string | string | StockCommodityMoves>("/API/futures_ts/", { params: { filter } });

    if (typeof res.data === "string") return JSON.parse(res.data.replaceAll("NaN", null)).index;
    return res.data;
};

export const getStockCommodityMovesForScatterPlot = async (filter: number | string, stock_id: number) => {
    const res = await axios.get(`/API/scatter_data/?GUIv=2&name_1=${filter}&stock_id_2=${stock_id}`);

    return res.data;
};
